import * as React from 'react';
import clsx from 'clsx';

const rootStylesMap = {
  horizontal: 'w-full',
  vertical: 'flex-col items-stretch'
};
const borderDirectionMap = {
  horizontal: 'border-b',
  vertical: 'border-r'
};
const borderStyleMap = {
  solid: 'border-solid',
  dashed: 'border-dashed'
};
function Divider({
  children,
  className,
  borderStyle = 'solid',
  direction = 'horizontal',
  borderColor = 'border-gray'
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('flex items-center', rootStylesMap[direction], className)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex-1 border-0', borderColor, borderStyleMap[borderStyle], borderDirectionMap[direction])
  }), children, /*#__PURE__*/React.createElement("div", {
    className: clsx('flex-1 border-0', borderColor, borderStyleMap[borderStyle], borderDirectionMap[direction])
  }));
}

export { Divider };
